import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

import logo from '../../ssl-logo.png';

import SideScreenOverlay from '../sections/SideScreenOverlay';

function PrivacyPage(){
    return (
        <> 
            <Row>
                <Col className="bg-dark">
                    <img src="/ssl-logo-white.png" className="App-logo" alt="logo" />
                    <p>
                    ...coming soon
                    </p>
                </Col>
            </Row>
            <Row>
                <Col md={{ span: 8, offset: 2}}>
                    
    <h1>Privacy Policy</h1>
    <p><strong>Effective Date:</strong> June 17, 2026 &nbsp;|&nbsp; <strong>Version:</strong> 2.3</p>

    <hr />

    <i> DATA CONTROLLER & CONTACT </i>
    <h2>Data Controller &amp; Contact</h2>
    <p><strong>Your E‑commerce Store Ltd.</strong><br />
    123 Commerce Ave, Suite 200, New York, NY 10001</p>
    <p><strong>Email:</strong> <a href="mailto:privacy@yourstore.com">privacy@yourstore.com</a><br />
    <strong>Phone:</strong> <a href="tel:+15551234567">+1 (555) 123‑4567</a><br />
    <strong>Website:</strong> www.yourstore.com</p>
    <p>We are committed to protecting your privacy. This policy explains how we collect, use, share, and safeguard your personal information when you visit our website or use our services.</p>

    <hr />

    <i> 1. WHAT DATA </i>
    <h2>1. What Data We Collect</h2>
    <p>We collect personal information you provide to us directly, as well as technical and usage data automatically.</p>
    <ul>
        <li><strong>Personal Identification:</strong> name, email, shipping/billing address, phone number.</li>
        <li><strong>Account Details:</strong> username, password (encrypted), order history, wishlist.</li>
        <li><strong>Payment Information:</strong> card details, billing address (processed by our PCI‑compliant payment partners).</li>
        <li><strong>Technical &amp; Usage Data:</strong> IP address, browser type, device info, pages viewed, search queries, referral source.</li>
    </ul>
    <p><strong>Example:</strong> When you make a purchase, we collect your name, address, and payment details to fulfill your order. We also use cookies to remember your cart and preferences.</p>

    <hr />

    <i> 2. HOW WE USE </i>
    <h2>2. How We Use Your Data</h2>
    <ul>
        <li><strong>Order Fulfillment:</strong> process payments, arrange shipping, send order confirmations and invoices.</li>
        <li><strong>Communication:</strong> respond to inquiries, send service notifications, and provide customer support.</li>
        <li><strong>Site Improvement &amp; Analytics:</strong> analyze usage patterns, optimize user experience, and detect fraud.</li>
        <li><strong>Marketing (with consent):</strong> send personalized offers, product recommendations, and targeted ads.</li>
    </ul>
    <table>
        <thead>
            <tr>
                <th>Purpose</th>
                <th>Legal Basis</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Order fulfillment &amp; shipping</td>
                <td>Contract performance</td>
            </tr>
            <tr>
                <td>Analytics &amp; site optimization</td>
                <td>Legitimate interest</td>
            </tr>
            <tr>
                <td>Personalized marketing</td>
                <td>Consent (opt‑in)</td>
            </tr>
        </tbody>
    </table>

    <hr />

    <i> 3. SHARING </i>
    <h2>3. How We Share Information</h2>
    <p>We share your data with trusted third parties to operate our business. These include:</p>
    <ul>
        <li><strong>Service Providers:</strong> payment processors (Stripe, PayPal), shipping carriers (UPS, FedEx), and IT infrastructure (cloud hosting).</li>
        <li><strong>Analytics &amp; Marketing:</strong> Google Analytics, Facebook Pixel, and ad networks to measure performance and deliver relevant ads.</li>
        <li><strong>Legal Compliance:</strong> when required by law, to respond to subpoenas, or to protect our rights and safety.</li>
    </ul>
    <p>We do not sell your personal data to third parties for their own marketing purposes without your explicit consent.</p>

    <hr />

    <i> 4. COOKIES & TRACKING </i>
    <h2>4. Cookies &amp; Tracking Technologies</h2>
    <p>We use cookies and similar technologies to enhance your browsing, personalize content, and analyze traffic. You can manage your cookie preferences in your browser settings.</p>
    <ul>
        <li><strong>Essential cookies:</strong> enable core functionality (cart, checkout).</li>
        <li><strong>Analytics cookies:</strong> help us understand how visitors interact with our site.</li>
        <li><strong>Advertising cookies:</strong> deliver relevant promotions and measure campaign effectiveness.</li>
    </ul>
    <p>You can opt out of targeted advertising via our <a href="#">Privacy Choices</a> page or by adjusting your device settings.</p>

    <hr />

    <i> 5. DATA SECURITY </i>
    <h2>5. Data Protection &amp; Security</h2>
    <p>We implement robust security measures to safeguard your information:</p>
    <ul>
        <li><strong>Encryption:</strong> SSL/TLS for all data in transit; sensitive data (passwords, payment info) is hashed or tokenized.</li>
        <li><strong>Access Control:</strong> restricted to authorized personnel only, with regular security training.</li>
        <li><strong>Monitoring:</strong> 24/7 system monitoring and vulnerability assessments.</li>
    </ul>
    <p>While no system is completely secure, we continually update our practices to protect against unauthorized access.</p>

    <hr />

    <i> 6. USER RIGHTS </i>
    <h2>6. Your Privacy Rights</h2>
    <p>Depending on your location (e.g., GDPR, CCPA), you may have the following rights:</p>
    <ul>
        <li><strong>Access:</strong> request a copy of your personal data.</li>
        <li><strong>Rectification:</strong> correct inaccurate or incomplete data.</li>
        <li><strong>Erasure:</strong> request deletion of your data (subject to legal obligations).</li>
        <li><strong>Opt‑Out:</strong> opt out of the sale of your data or targeted advertising.</li>
        <li><strong>Data Portability:</strong> receive your data in a structured, machine‑readable format.</li>
    </ul>
    <p>To exercise any of these rights, contact us at <a href="mailto:privacy@yourstore.com">privacy@yourstore.com</a>. We will respond within 30 days.</p>

    <hr />

    <i> 7. RETENTION & CHILDREN </i>
    <h2>7. Data Retention &amp; Children</h2>
    <h3>Retention</h3>
    <p>We retain order information for as long as necessary to fulfill the purposes outlined, or as required by tax/accounting laws. You may request deletion at any time.</p>
    <h3>Children</h3>
    <p>Our site is not intended for individuals under the age of 16. We do not knowingly collect personal information from children. If you believe a child has provided us with data, please contact us immediately.</p>

    <hr />

    <i> 8. UPDATES </i>
    <h2>8. Changes to This Policy</h2>
    <p>We may update this privacy policy periodically to reflect changes in our practices, legal requirements, or operational needs. We will notify you of any material changes by posting the new policy on this page and updating the “Effective Date” above. We encourage you to review this policy regularly.</p>

    <hr />

    <i> CONTACT / FOOTER </i>
    <h2>Contact Us</h2>
    <p><strong>Email:</strong> <a href="mailto:privacy@yourstore.com">privacy@yourstore.com</a><br />
    <strong>Phone:</strong> <a href="tel:+15551234567">+1 (555) 123‑4567</a><br />
    <strong>Address:</strong> 123 Commerce Ave, Suite 200, New York, NY 10001</p>
    <p><strong>Data Protection Officer:</strong> dpo@yourstore.com</p>
    <p><em>Last updated: June 17, 2026</em></p>

    <hr />

    <i> optional quick reference table </i>
    <h3>Quick Reference: Data Processing Summary</h3>
    <table>
        <thead>
            <tr>
                <th>Data Category</th>
                <th>Purpose</th>
                <th>Retention Period</th>
            </tr>
        </thead>
        <tbody>
            <tr>
                <td>Personal Identification</td>
                <td>Order fulfillment, shipping, customer service</td>
                <td>7 years (tax/legal)</td>
            </tr>
            <tr>
                <td>Payment Information</td>
                <td>Transaction processing</td>
                <td>As required by payment partners</td>
            </tr>
            <tr>
                <td>Technical / Usage Data</td>
                <td>Analytics, site optimization</td>
                <td>26 months (Google Analytics)</td>
            </tr>
            <tr>
                <td>Marketing Preferences</td>
                <td>Personalized offers &amp; ads</td>
                <td>Until consent withdrawn</td>
            </tr>
        </tbody>
    </table>

    <p><strong>Your privacy matters.</strong> If you have any questions or concerns, please reach out to us.</p>
                </Col>
            </Row>
        </>
    )
}

export default PrivacyPage;